import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockBooks } from '../services/dataService';
import { getBookImage } from '../utils/imageUtils';

/**
 * Book Details Page Component
 */
const BookDetails = () => {
  const { id } = useParams();
  const book = mockBooks.find(b => b.id === id);
  const [cart, setCart] = useState([]);

  if (!book) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>Book not found</h2>
        <Link to="/marketplace" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to Marketplace</Link>
      </div>
    );
  }

  const addToCart = () => {
    setCart([...cart, book]);
    alert(`${book.title} added to cart!`);
  };

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/marketplace" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to Marketplace
      </Link>

      <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '30px' }}>
        {/* Book Image */}
        <div className="card" style={{ height: 'fit-content', textAlign: 'center' }}>
          <img 
            src={getBookImage(book.id, book.title)} 
            alt={book.title}
            style={{ 
              width: '100%', 
              height: '400px', 
              objectFit: 'cover', 
              borderRadius: '10px',
              marginBottom: '20px'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div style={{ marginTop: '20px', fontSize: '28px', color: 'var(--highlight-color)', fontWeight: 'bold' }}>
            ${book.price.toFixed(2)}
          </div>
          <div style={{ marginTop: '10px', marginBottom: '20px' }}>
            ⭐ {book.rating}/5.0
          </div>
          <button onClick={addToCart} className="btn btn-primary" style={{ width: '100%', marginBottom: '10px' }}>
            Add to Cart
          </button>
          <button className="btn btn-secondary" style={{ width: '100%' }}>
            Buy Now
          </button>
        </div>

        {/* Book Details */}
        <div className="card">
          <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
            {book.title}
          </h1>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              <strong>Author:</strong> {book.author}
            </p>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              <strong>Category:</strong> {book.category}
            </p>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              <strong>Rating:</strong> ⭐ {book.rating}/5.0
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Description</h3>
            <p style={{ color: 'var(--text-dark)', lineHeight: '1.8', fontSize: '16px' }}>
              {book.description}
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>About This Book</h3>
            <p style={{ color: 'var(--text-dark)', lineHeight: '1.8', fontSize: '16px' }}>
              This comprehensive book provides an in-depth exploration of {book.category.toLowerCase()} topics, 
              written by renowned expert {book.author}. Perfect for students, professionals, and enthusiasts 
              looking to deepen their understanding of the field.
            </p>
          </div>

          <div style={{ marginTop: '30px', padding: '20px', background: 'var(--card-hover)', borderRadius: '10px' }}>
            <h3 style={{ marginBottom: '15px', color: 'var(--highlight-color)' }}>Key Features</h3>
            <ul style={{ paddingLeft: '20px', color: 'var(--text-dark)' }}>
              <li>Comprehensive coverage of key topics</li>
              <li>Expert insights and real-world examples</li>
              <li>Illustrations and diagrams</li>
              <li>Practical applications and case studies</li>
              <li>Suitable for all knowledge levels</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookDetails;
